module.exports = {"attributes":{"viewBox":"0 0 15 19"},"content":"<g fill=\"none\" fill-rule=\"nonzero\">     <path fill=\"#0084FF\" d=\"M4.6 12.7c1-1.5 1.2-3 1.2-3s.8 1.1.4 2.7c1.4-1.5 1.6-4 1.4-5 3 2.2 4.4 7 2.6 10.6 9.4-5.5 2.4-13.7 1.1-14.6.4.9.5 2.5-.3 3.2C9.6 1.1 6.2 0 6.2 0c.4 2.8-1.5 6-3.3 8.2 0-1-.1-1.9-.7-3C2 7.4.6 9 .2 11c-.6 2.8.4 4.8 4 7-1.1-2.5-.5-4 .4-5.3z\"/>     <path fill=\"#A4D3FE\" d=\"M4.6 12.7c1-1.5 1.2-3 1.2-3s.8 1.1.4 2.7c1.4-1.5 1.6-4 1.4-5 3 2.2 4.4 7 2.6 10.6 0 0-4.4.5-6 0-1.1-2.5-.5-4 .4-5.3z\"/>   </g>"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-hot.svg
// module id = 1286
// module chunks = 0